import { render, staticRenderFns } from "./ClientesLog.vue?vue&type=template&id=519d4ffd&scoped=true"
import script from "./ClientesLog.vue?vue&type=script&lang=js"
export * from "./ClientesLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519d4ffd",
  null
  
)

export default component.exports